<template>
  <div class="lateral-buttons">
    <!-- Rankings button -->
    <button 
      class="rankings-button" 
      @click="openRankings" 
      title="Rankings"
    >
      <i class="fas fa-trophy"></i>
    </button>
    
    <!-- Fullscreen button -->
    <button 
      class="fullscreen-button" 
      @click="toggleFullscreen" 
      :title="isFullscreen ? 'Sair da tela cheia' : 'Tela cheia'"
    >
      <i class="fullscreen-icon" :class="{ 'is-active': isFullscreen }"></i>
    </button>
  </div>
</template>

<script>
import screenfull from 'screenfull';
import { mapActions } from 'vuex';

export default {
  name: 'LateralButtons',
  data() {
    return {
      isFullscreen: false
    };
  },
  mounted() {
    // Set up event listener for fullscreen changes
    if (screenfull.isEnabled) {
      screenfull.on('change', () => {
        this.isFullscreen = screenfull.isFullscreen;
      });
    }
  },
  methods: {
    ...mapActions('rankings', ['toggleRankingsModal']),
    ...mapActions('SoundController', ['playSound']),
    
    openRankings() {
      // Make sure store and module exist before trying to access them
      if (this.$store && this.$store.state.rankings) {
        this.toggleRankingsModal(true);
        
        // Play UI sound if enabled and SoundController exists
        if (this.$store.state.SoundController && !this.$store.state.SoundController.isSoundMuted) {
          this.playSound({ category: 'ui', type: 'click' });
        }
      } else {
        console.error('Rankings module not available in store');
      }
    },
    
    toggleFullscreen() {
      if (screenfull.isEnabled) {
        screenfull.toggle();
      } else {
        // For iOS devices that don't support standard fullscreen
        this.attemptIOSFullscreen();
      }
    },
    
    attemptIOSFullscreen() {
      // For iOS devices, we can suggest adding to home screen
      // as PWAs can run in standalone mode (similar to fullscreen)
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      
      if (isIOS) {
        alert('Para uma experiência em tela cheia no iOS, adicione este site à sua tela inicial.');
      } else {
        alert('Tela cheia não é suportada no seu dispositivo.');
      }
    }
  },
  beforeUnmount() {
    // Clean up event listeners
    if (screenfull.isEnabled) {
      screenfull.off('change');
    }
  }
}
</script>

<style lang="scss" scoped>
.lateral-buttons {
  position: fixed;
  right: 5px;
  bottom: 130px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 15px;
  @media screen and (max-width: 768px) {
    bottom: 110px;
  }
}

.fullscreen-button, .rankings-button {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #ff3e3e;
  color: white;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  transition: background-color 0.3s, transform 0.2s;
}

.fullscreen-button:hover, .rankings-button:hover {
  background-color: rgba(0, 0, 0, 0.9);
  transform: scale(1.05);
}

.rankings-button {
  background-color: #c41e3a;
  font-size: 1.2rem;
}

.rankings-button:hover {
  background-color: #9a1730;
}

.fullscreen-icon {
  width: 24px;
  height: 24px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white'%3E%3Cpath d='M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z'/%3E%3C/svg%3E");
  background-size: contain;
  background-repeat: no-repeat;
  transition: background-image 0.3s;
}

.fullscreen-icon.is-active {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white'%3E%3Cpath d='M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z'/%3E%3C/svg%3E");
}
</style>
